






































import { Component } from "vue-property-decorator";
import Vue from "vue";
import CardListPasienRanap from "@/components/dashboard/CardListPasienRanap.vue";
import DataList from "../services/DataList";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { pusher } from "@/services/PusherClient";
import { storeKonsul } from "@/store/modules/konsul";
import PasienKonsulanCard from "./DaftarPasienPage/PasienKonsulanCard.vue";
import EncounterIndex from "@/store/modules/EncounterIndex";
import ListPasienTransferInternal from "@/components/pti/ListPasienTransferInternal.vue";
import OrderBankDarahPage from "@/pages/bank-darah/OrderBankDarahPage.vue";


@Component({
  components: {
    CardListPasienRanap,
    PasienKonsulanCard,
    ListPasienTransferInternal,
    OrderBankDarahPage
  },
  beforeRouteLeave(to, from, next) {
    pusher.unsubscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);

    next();
  }
})
export default class DaftarPasien extends Vue {
  cm = "";
  pasien: Array<object> = [];
  hdn = "";
  loading = true;
  showFilterDokter = true;
  errListPx = "0";
  errPx = "0";
  reg = "";
  sess_login = this.stateuser;
  today = new Date().toISOString().substr(0, 10);
  listPasienTransfer: Array<object> = [];

  mounted() {
    if (this.modeBankDarah) {
      appModule.setLoading(false);
      return;
    }

    appModule.setLoading(true);

    setTimeout(() => {
      this.GetPasien();
      //this.GetPasienTransfer();
    }, 300);

    EncounterIndex.getPasienRanapDilayani();
  }

  get stateuser() {
    return userModule.user;
  }

  get modeBankDarah(): boolean {
    return (
      (userModule.loginUnitId || "").trim() === "35" &&
      userModule.hasPrivilege("bank_darah_order", "view")
    );
  }

  get showLoading() {
    return appModule.loading;
  }

  get showKonsulanCard() {
    return true;
  }

  get listKonsul() {
    return storeKonsul.listKonsul;
  }

  GetPasien() {
    this.loading = true;

    const dt = DataList.getListPasienRanap(this.sess_login["unit_id"]);
    dt.then(dt => {
      appModule.setLoading(false);
      if (dt["status"] != 1) {
        this.errListPx = "1";
      } else {
        this.pasien = dt.data;
        //   this.btn = "hidden";
        this.hdn = "";
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  // GetPasienTransfer() {
  //   const dt = TransferDiterima.getByToUnit(Number(this.sess_login["unit_id"]));
  //   dt.then(dt => {
  //     if (dt["status"] === 1) {
  //       this.listPasienTransfer = dt.data || [];
  //     } else {
  //       this.listPasienTransfer = [];
  //     }
  //   }).catch(() => {
  //     this.listPasienTransfer = [];
  //   });
  // }

  reloadListPx() {
    this.errListPx = "0";
    this.GetPasien();
    //this.GetPasienTransfer();
  }

  jawabKonsul() {
    //
  }

  getListPasien() {
    this.GetPasien();
  }

  handlePilihPasien(item: unknown) {
    // Handle ketika pasien dipilih dari list transfer
    console.log('Pasien dipilih:', item);
  }

  handleTerimaPasien(data: unknown) {
    // Handle ketika pasien diterima/accepted
    console.log('Pasien diterima:', data);
    this.reloadListPx();
  }
}
